import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern traffic light: a 3 m pole with a black signal head facing +Z and
// three lamp discs — red, amber, green top to bottom — proud of the face.
const BLACK = "#2e2e30";
const CONCRETE = "#9a9a94";
const RED = "#b04a3a";
const AMBER = "#d0a04a";
const GREEN = "#5f9a52";

/** A lamp disc facing +Z, proud of the signal head face. */
function lamp(color: string, y: number): Part {
  return {
    geometry: new THREE.CylinderGeometry(0.085, 0.085, 0.05, 12),
    color,
    position: [0, y, 0.25],
    rotation: [Math.PI / 2, 0, 0],
  };
}

export const trafficSignal = defineModel({
  id: "traffic-signal",
  batchId: "modern",
  name: "Traffic signal",
  tags: ["modern", "outdoor", "street", "traffic", "signal", "crossing"],
  summary: "A traffic light on a 3 m pole, lamps facing +Z.",
  description:
    "A street traffic light of the Modern Living kit: a matte-black 3 m pole " +
    "on a small concrete foot carrying a black signal head near the top. " +
    "Three lamp discs — red, amber, green top to bottom — sit proud of the " +
    "+Z face. Rotate in 90-degree steps to face each approach.",
  tiles: { w: 1, h: 1 },
  footprint: 1.8,
  parts(): Part[] {
    return [
      // Concrete foot.
      {
        geometry: new THREE.CylinderGeometry(0.12, 0.15, 0.1, 10),
        color: CONCRETE,
        position: [0, 0.05, 0],
      },
      // Pole.
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.06, 3.0, 8),
        color: BLACK,
        position: [0, 1.5, 0],
      },
      // Signal head facing +Z.
      {
        geometry: new THREE.BoxGeometry(0.3, 0.78, 0.22),
        color: BLACK,
        position: [0, 2.55, 0.13],
      },
      lamp(RED, 2.78),
      lamp(AMBER, 2.55),
      lamp(GREEN, 2.32),
    ];
  },
  animations: [],
});
